import { CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Image,
  Stack,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { config } from "../config";
import LanguageSelector from "./language-selector";
import Role from "./role";

import Logo from "../assets/logo.jpg";

type NavLinkProps = {
  children: React.ReactNode;
  path: string;
};

type NavItem = {
  label: string;
  path: string;
  roles?: string[];
};

const Links: NavItem[] = [
  { label: "ebooks", path: "/ebooks" },
  { label: "reports", path: "/reports" },
  { label: "ebookSetup", path: "/ebook-setup", roles: ["EbookTeamMember"] },
  // { label: "ratings", path: "/ratings" },
];

const NavLink = (props: NavLinkProps): JSX.Element => {
  const { children, path } = props;
  return (
    <Link to={path} style={{ textDecoration: "none" }}>
      <Box
        px={2}
        py={1}
        rounded={"md"}
        _hover={{
          textDecoration: "none",
          bg: useColorModeValue("gray.200", "gray.700"),
        }}
      >
        {children}
      </Box>
    </Link>
  );
};

export const Header = (): JSX.Element => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation();
  const location = useLocation();

  const goToOldVersion = (): void => {
    const baseHost = config.apiHost || "";
    if (window.location.href.includes("ebooks")) {
      // @ts-ignore
      return (window.location.href = `${baseHost}/secure/ebookListPage`);
    }
    if (window.location.href.includes("reports")) {
      // @ts-ignore
      return (window.location.href = `${baseHost}/secure/userReportPage`);
    }
    // if (window.location.href.includes("ratings")) {
    //   // @ts-ignore
    //   return (window.location.href = `${baseHost}/secure/ratingList`);
    // }
  };

  return (
    <Box bg={useColorModeValue("gray.100", "gray.900")} px={4} position="sticky" top={0} zIndex={10}>
      <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
        <HStack spacing={8} alignItems={"center"} flexShrink={0}>
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <Box>
            <Image src={Logo} alt="Logo" />
          </Box>
          <HStack as={"nav"} spacing={4} display={{ base: "none", md: "flex" }}>
            {Links.map((link: NavItem): JSX.Element => {
              const navItem: JSX.Element = (
                <NavLink key={link.path} path={link.path}>
                  <span
                    style={{
                      fontWeight: location.pathname.includes(link.path)
                        ? 700
                        : undefined,
                    }}
                  >
                    {t(link.label)}
                  </span>
                </NavLink>
              );
              return link.roles ? (
                <Role key={link.path} roles={link.roles}>
                  {navItem}
                </Role>
              ) : (
                navItem
              );
            })}
          </HStack>
        </HStack>
        <Flex alignItems={"center"} gap={4} flexShrink={0} position="sticky" right={0} bg="inherit">
          <LanguageSelector />
          <Button
            variant="outline"
            colorScheme={"teal"}
            size={"sm"}
            onClick={goToOldVersion}
          >
            Old Version
          </Button>
          <a href="/perform_logout">
            <Button variant={"solid"} colorScheme={"teal"} size={"sm"}>
              {t("logout")}
            </Button>
          </a>
        </Flex>
      </Flex>
      {isOpen ? (
        <Box pb={4} display={{ md: "none" }}>
          <Stack as={"nav"} spacing={4}>
            {Links.map((link: NavItem): JSX.Element => {
              const navItem: JSX.Element = (
                <NavLink key={link.path} path={link.path}>
                  {t(link.label)}
                </NavLink>
              );
              return link.roles ? (
                <Role key={link.path} roles={link.roles}>
                  {navItem}
                </Role>
              ) : (
                navItem
              );
            })}
          </Stack>
        </Box>
      ) : null}
    </Box>
  );
};

export default Header;
